import React from 'react';

import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { StatusBarWrapper, BoxWrapper } from './css';

const BrpStatusBar = ({ onProceedClick, onBackClick, step, isLastStep }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    formButtons: { continueButtonLabel, backLabel, submitButtonLabel }
  } = localizedStrings;

  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
          <>
            {step > 1 && (
              <button
                type="button"
                onClick={onBackClick}
                className="frg-button color-green"
              >
                {backLabel}
              </button>
            )}

            <button
              type="button"
              onClick={e => onProceedClick(e)}
              style={{ marginLeft: '1em' }}
              className={`frg-button color-${isLastStep ? 'purple' : 'green'}`}
            >
              {isLastStep ? submitButtonLabel : continueButtonLabel}
            </button>
          </>
        </BoxWrapper>
      </div>
    </StatusBarWrapper>
  );
};

BrpStatusBar.propTypes = {
  step: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired
};

export default BrpStatusBar;
